
export const SIDER_TOGGLE = "common.sider.toggle";

//侧边栏切换
export const toggleSider = () => ({
  type: SIDER_TOGGLE
});
